const userStatisticActionTypes = {
  GET_STATISTIC_START: 'GET_STATISTIC_START',
  GET_STATISTIC_SUCCESS: 'GET_STATISTIC_SUCCESS',
  GET_STATISTIC_FAILURE: 'GET_STATISTIC_FAILURE',

  GET_ABOUT_START: 'GET_ABOUT_START',
  GET_ABOUT_SUCCESS: 'GET_ABOUT_SUCCESS',
  GET_ABOUT_FAILURE: 'GET_ABOUT_FAILURE',

  SET_ABOUT_START: 'SET_ABOUT_START',
  SET_ABOUT_SUCCESS: 'SET_ABOUT_SUCCESS',
  SET_ABOUT_FAILURE: 'SET_ABOUT_FAILURE',
};

export default userStatisticActionTypes;
